import { z } from 'zod';

/** The session token a successful login answers with. */
export const loginSchema = z.looseObject({ token: z.string().min(1) });

// How a known user signs in. An answer without data is read as a username the API does not know.
export const authModesSchema = z
    .looseObject({ login_by_sso: z.boolean().nullish().transform(Boolean) })
    .nullish()
    .transform((authModes) => authModes ?? null);

// The identity provider's page that ends its session; without one, the app sends the user to its own ADFS sign-in.
export const adfsLogoutSchema = z
    .looseObject({ uri: z.string().nullish() })
    .nullish()
    .transform((logout) => logout?.uri ?? null);
